import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 553280 680000"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g>
      <g id="_1974337322128">
        <path
          d="M316210 141840c0 21960-17670 39660-39600 39660-21790-10-39540-17700-39540-39660 0-21810 17750-39540 39540-39540 21930 0 39590 17730 39600 39540zM431540 201250c0 21930-17750 39620-39570 39620-21920 0-39670-17690-39670-39620 0-21820 17750-39570 39670-39570 21820 0 39570 17750 39570 39570zM200930 260740c0 21820-17720 39570-39630 39570-21880 0-39570-17750-39570-39570 0-21920 17690-39650 39570-39650 21910 0 39630 17730 39630 39650z"
          className="fil0"
        />
        <path d="M295270 568520h-37210V169100h37210z" className="fil0" />
        <path
          d="M263520 505790 142730 385040V236180h37200v133470l109830 109850zM289760 420200l-26240-26340 109840-109830v-83900h37170v99290z"
          className="fil0"
        />
        <path
          d="M276610 32320c-134720 0-244300 109610-244300 244300v126710c0 134720 109580 244340 244300 244340s244300-109610 244300-244340V276620c0-134700-109580-244300-244300-244300zm0 647680C124120 680000 0 555910 0 403330V276620C0 124090 124120 0 276610 0c152550 0 276670 124090 276670 276620v126710c0 152580-124120 276670-276670 276670z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
